import { render } from "./ModalTip.vue?vue&type=template&id=2d0705fe&scoped=true"
import script from "./ModalTip.vue?vue&type=script&lang=js"
export * from "./ModalTip.vue?vue&type=script&lang=js"

import "./ModalTip.vue?vue&type=style&index=0&id=2d0705fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0705fe"]])

export default __exports__